<!--
Author: TangChen
Date: 2018-09-10
Desc: 设置未开户下页面顶部导航，为公共组件
 -->
<template>
    <div class="comp-nav-bar comp">
        <div class="nav-bar">
            <div v-for="(nav,index) in navs" :key="nav.val" class="nav-list" :style="{width:parseFloat(100/navs.length).toFixed(1)+'%'}" :class="{'is-active':nav.active}">
                <span v-if="!nav.icon" class="nav-list-id">{{ index+1 }}</span>
                <span v-if="nav.icon" class="nav-list-id"> <i :class="nav.icon" /></span>
                <span class="nac-list-text">{{ nav.val }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NavBar",
    props: {
        navs: {
            type: Array,
            required: true
        }
    },
    data () {
        return {};
    },
    methods: {
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.comp-nav-bar {
  .nav-bar {
    border-bottom: 2px solid $border-color3;
    text-align: center;
    .nav-list {
      display: inline-block;
      vertical-align: middle;
      padding: 8px 0;
      line-height: 26px;
      font-size: $f18;
      color: $text-color7;
      &.is-active {
        color: $color-a;
        position: relative;
        .nav-list-id {
          color: $text-color6;
          background: $bg4;
        }
      }
      &.is-active:before {
        content: '';
        width: 100%;
        height: 2px;
        background: $bg4;
        position: absolute;
        bottom: -2px;
        left: 0;
      }
      .nav-list-id {
        display: inline-block;
        width: 26px;
        height: 26px;
        border-radius: 100% 100%;
        -webkit-border-radius: 100% 100%;
        background: $bg9;
        color: $text-color8;
        font-size: $f20;
        margin-right: 15px;
      }
    }
  }
}
</style>
